<av-content-container>
  <div class="col-12 mb-4 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.local_admin.sections.admin_groups.title'" icon="group"
      [columns]="adminGroupColumns" [rows]="adminGroupRows()"
      [countLabelKey]="'app.device.local_admin.count.admin_groups_found_suffix'"
      [emptyTextKey]="'app.device.local_admin.empty.admin_groups'" [pageSize]="5" [truncateAfter]="100"
      [trackByKey]="'sid'" />
  </div>

  <div class="col-12 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.local_admin.sections.admin_accounts.title'" icon="manage_accounts"
      [columns]="adminAccountColumns" [rows]="adminAccountRows()"
      [countLabelKey]="'app.device.local_admin.count.admin_accounts_found_suffix'"
      [emptyTextKey]="'app.device.local_admin.empty.admin_accounts'" [pageSize]="5" [truncateAfter]="100"
      [trackByKey]="'sid'" />
  </div>
</av-content-container>